import React, { useState } from 'react';
import Modal from 'react-modal';
import Param from '../../pages/store/param';
import { 
  Typography, 
  Grid, 
  Paper, 
  Button, 
  List, 
  ListItem, 
  ListItemText, 
  Divider 
} from '@material-ui/core';
import FeedbackFormStyle from '../../pages/style/feedbackFormStyle';
import { TargetTimes } from './constants';

const FeedbackTime = ({ show, setter}) => {
  const classes = FeedbackFormStyle();
  const setup         = Param.Get('setup');
  const elapsedTimes   = setup.elapsedTimes;
  const startDateTime = setup.startDateTime; // Date format
  const endDateTime   = setup.endDateTime; // Date format

  // calculate modeling time as mins
  let modelingTime = (endDateTime - startDateTime) /1000 / 60;
  // format modeling time to 2 decimal places
  modelingTime = modelingTime.toFixed(2);

  let modelingTimeExcludeInactive = Object.values(elapsedTimes).reduce((acc, time) => acc + time, 0) / 1000 / 60;
  modelingTimeExcludeInactive = modelingTimeExcludeInactive.toFixed(2);

  const workflowTimes = [
    { name: 'Setup', time: elapsedTimes[0], target: TargetTimes[0] }, // target time in seconds
    { name: 'Alignment', time: elapsedTimes[1], target: TargetTimes[1] },
    { name: 'Base Shape', time: elapsedTimes[2], target: TargetTimes[2] },
    { name: 'Compression', time: elapsedTimes[3], target: TargetTimes[3] },
    { name: 'Lower Trim', time: elapsedTimes[4], target: TargetTimes[4] },
    { name: 'Upper Surface', time: elapsedTimes[5], target: TargetTimes[5] },
    { name: 'Assemble', time: elapsedTimes[6], target: TargetTimes[6] },
    { name: 'Output', time: elapsedTimes[7], target: TargetTimes[7] },
  ];

  return (
    <Modal
      isOpen={show}
      onClose={() => setter(false)}
      className={classes.modal}
      aria-labelledby="feedback-time-modal"
      aria-describedby="feedback-time-description"
    >
      <Paper className={classes.paper}>
        <Typography variant="h4" className={classes.title}>
          Modeling Time Feedback
        </Typography>
        
        <Typography variant="body1">
          Modeling time (Includes inactive time): {modelingTime} minutes
        </Typography>
        <Typography variant="body1">
          Modeling time (Only active time): {modelingTimeExcludeInactive} minutes
        </Typography>

        <Typography variant="h5" className={classes.subtitle}>
          Elapsed time for each workflow (active time only)
        </Typography>

        <List>
          {workflowTimes.map((item, index) => {
            const isAchieved = item.time <= item.target * 1000;
            const percentage = ((item.time / 1000) / item.target * 100).toFixed(1);
            return (
              <React.Fragment key={item.name}>
                <ListItem className={classes.listItem}>
                  <ListItemText
                    primary={
                      <div style={{ color: isAchieved ? 'green' : 'red' }}>
                        <span>{item.name}</span>
                        <span style={{ marginLeft: '10px' }}>
                          {`${(item.time / 1000).toFixed(1)} seconds`} (Target: {item.target} seconds, {percentage}%)
                        </span>
                      </div>
                    }
                  />
                </ListItem>
                {index < workflowTimes.length - 1 && <Divider />}
              </React.Fragment>
            );
          })}
        </List>

        <Grid container justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={() => setter(false)}
            className={classes.closeButton}
          >
            Close
          </Button>
        </Grid>
      </Paper>
    </Modal>
  );
}

export default FeedbackTime